exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".oprationLogTable .sc-form .sc-inline:first-child {\n  width: 100%;\n}\n.oprationLogTable .sc-table tr td:nth-child(3) {\n  white-space: pre-wrap;\n  word-break: break-all;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-align: left;\n}\n.not-search-tip {\n  width: 100%;\n  height: auto;\n  padding: 30px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  background: #fff;\n}\n.not-search-tip img {\n  width: 415px;\n  height: auto;\n}\n.not-search-tip .nosearchWZ .wz1 {\n  line-height: 33px;\n  font-size: 24px;\n  color: #000;\n  font-weight: bold;\n  padding-bottom: 16px;\n}\n.not-search-tip .nosearchWZ .wz2 {\n  line-height: 20px;\n  font-size: 14px;\n  color: #666;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/oprationLog.styl
// module id = 4787
// module chunks = 0